import parse from 'html-react-parser';
import { INK } from '../Landing/ui';

// FAQ accordion in the Landing/Faq idiom. The keyword→affiliate-link
// replacements are revenue-bearing — keep them in sync with the JSON-LD
// answers emitted via the Head faq prop (which stay un-linked).
export default function GuideFaq({
  faq,
  rentalCarLink,
  busLink,
  privateDriverLink,
  taxiLink,
  toursLink,
}) {
  if (!faq || faq.length === 0) return null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      {faq.map(faqItem => (
        <details
          key={faqItem.questionName}
          className="tw-group tw-rounded-2xl tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-white dark:tw-bg-[#15231E] tw-px-6 tw-py-1 open:tw-pb-5"
        >
          <summary
            className={`${INK} tw-flex tw-cursor-pointer tw-list-none tw-items-center tw-justify-between tw-gap-4 tw-py-4 tw-text-base tw-font-semibold sm:tw-text-lg [&::-webkit-details-marker]:tw-hidden`}
          >
            {faqItem.questionName}
            <span
              aria-hidden="true"
              className="tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-600/10 dark:tw-bg-primary-300/20 tw-text-lg tw-font-medium tw-text-primary-700 dark:tw-text-primary-300 tw-transition-transform tw-duration-200 group-open:tw-rotate-45"
            >
              +
            </span>
          </summary>
          <div className="tf-guide-faq tw-pr-8 tw-text-[15px] tw-leading-relaxed tw-text-[#5F6F69] dark:tw-text-[#93A69E]">
            {parse(
              faqItem.acceptedAnswerText
                .replace(
                  /(renting a car)/gi,
                  `<a href="${rentalCarLink}">$1</a>`,
                )
                .replace(
                  / (rental car)/gi,
                  ` <a href="${rentalCarLink}">$1</a>`,
                )
                .replace(/ (buses)/gi, ` <a href="${busLink}">$1</a>`)
                .replace(/ (bus) /gi, ` <a href="${busLink}">$1</a> `)
                .replace(/ (train) /gi, ` <a href="${busLink}">$1</a> `)
                .replace(/ (trains)/gi, ` <a href="${busLink}">$1</a>`)
                .replace(
                  /(public transportation)/gi,
                  `<a href="${busLink}">$1</a>`,
                )
                .replace(
                  / (public transport)/gi,
                  ` <a href="${busLink}">$1</a>`,
                )
                .replace(
                  / (private driver)/gi,
                  ` <a href="${privateDriverLink}">$1</a>`,
                )
                .replace(/ (taxis)/gi, ` <a href="${taxiLink}">$1</a>`)
                .replace(/ (taxi)/gi, ` <a href="${taxiLink}">$1</a>`)
                .replace(/ (guided tours)/gi, ` <a href="${toursLink}">$1</a>`)
                .replace(/ (guided tour)/gi, ` <a href="${toursLink}">$1</a>`),
              {
                replace: domNode => {
                  if (domNode.name === 'a') {
                    domNode.attribs.target = '_blank';
                    domNode.attribs.rel = 'nofollow noreferrer noopener';
                  }
                },
              },
            )}
          </div>
        </details>
      ))}
      <style jsx global>{`
        /* Same link treatment as the post body (.postcontent p a in
           style.css): teal with a gradient that fills on hover — dark ink
           on the teal fill stays readable in both themes. */
        .tf-guide-faq a {
          color: #00796b;
          text-decoration: none;
          border-bottom: 2px solid #4db6ac;
          background-size: 100% 200%;
          background-image: linear-gradient(to top, #4db6ac 50%, transparent 50%);
          transition: background-position 0.2s;
        }
        .tw-dark .tf-guide-faq a {
          color: #80cbc4;
        }
        .tf-guide-faq a:hover,
        .tw-dark .tf-guide-faq a:hover {
          color: #1f1f1f;
          background-position: 0 100%;
        }
        .tf-guide-faq ul {
          padding-left: 1.3em;
          margin: 0 0 0.8em;
        }
        .tf-guide-faq li {
          margin-bottom: 0.3em;
        }
      `}</style>
    </div>
  );
}
